export const CloseIcon = ({
  strokeColor = "var(--color-bg-primary)",
  ...props
}: any) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g id="x">
      <path
        id="Vector "
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.52827 3.52729C3.78862 3.26694 4.21073 3.26694 4.47108 3.52729L7.99967 7.05589L11.5283 3.52729C11.7886 3.26694 12.2107 3.26694 12.4711 3.52729C12.7314 3.78764 12.7314 4.20975 12.4711 4.4701L8.94248 7.9987L12.4711 11.5273C12.7314 11.7876 12.7314 12.2098 12.4711 12.4701C12.2107 12.7305 11.7886 12.7305 11.5283 12.4701L7.99967 8.94151L4.47108 12.4701C4.21073 12.7305 3.78862 12.7305 3.52827 12.4701C3.26792 12.2098 3.26792 11.7876 3.52827 11.5273L7.05687 7.9987L3.52827 4.4701C3.26792 4.20975 3.26792 3.78764 3.52827 3.52729Z"
        fill={strokeColor}
      />
    </g>
  </svg>
);
